import { render, staticRenderFns } from "./制定开发合作.vue?vue&type=template&id=48717d56&scoped=true&"
import script from "./制定开发合作.vue?vue&type=script&lang=js&"
export * from "./制定开发合作.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48717d56",
  null
  
)

export default component.exports